export default __webpack_public_path__ + "static/media/interac.d60a6131.svg";